module.exports = __webpack_public_path__ + "static/media/ciniphilia_ang1.424aba62.PNG";